<template>
    <div class="logo-container">
        <OrderLogo
            :company-name="companyProfile.companyName"
            :company-logo="companyProfile.logoUrl"
        />

        <DisplayAddress
            class="display-address business-address"
            :name="companyProfile.companyName"
            :address1="companyProfile.address1"
            :address2="companyProfile.address2"
            :city="companyProfile.locality"
            :state="companyProfile.region"
            :zip="companyProfile.postalCode"
        />
    </div>
</template>

<script>
import { DisplayAddress } from '@keap-web/shared-ui';
import OrderLogo from './OrderLogo.vue';

export default {
    components: {
        DisplayAddress,
        OrderLogo,
    },

    props: {
        companyProfile: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/common';

.display-address {
    margin-top: $spacing-200;
    line-height: 1.3rem;
}

.logo-container {
    display: flex;
    flex-direction: column;
}

@media only screen and ($small) {
    .display-address {
        display: none;
    }
}
</style>
